import { emptyAdminApi as api } from "../../emptyAdminApi";
import {
  BundleApiResponse,
  BundleItem,
  BundleMutationResponse,
  CreateBundleRequest,
  UpdateBundleRequest,
  ValidateBundleResponse,
} from "./BundleItem";

export const addTagTypes = ["BundleDeals"] as const;
const SLUG = "/webshop/bundles/manage";

const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAllBundleDeals: build.query<
        BundleApiResponse,
        { activeOnly?: boolean } | void
      >({
        query: (params) => ({
          url: SLUG,
          method: "GET",
        }),
        providesTags: ["BundleDeals"],
      }),
      getBundleDealById: build.query<BundleItem, string>({
        query: (promoCode) => ({
          url: `${SLUG}?id=${encodeURIComponent(promoCode)}`,
          method: "GET",
        }),
        providesTags: ["BundleDeals"],
      }),
      postBundleDeals: build.mutation<
        BundleMutationResponse,
        CreateBundleRequest
      >({
        query: (body) => ({
          url: SLUG,
          method: "POST",
          body,
        }),
        invalidatesTags: ["BundleDeals"],
      }),
      putBundleDeals: build.mutation<
        BundleMutationResponse,
        UpdateBundleRequest
      >({
        query: (body) => ({
          url: SLUG,
          method: "PUT",
          body,
        }),
        invalidatesTags: ["BundleDeals"],
      }),
      deleteBundleDeals: build.mutation<
        { message: string; promoCode: string },
        string
      >({
        query: (promoCode) => ({
          url: `${SLUG}?id=${encodeURIComponent(promoCode)}`,
          method: "DELETE",
        }),
        invalidatesTags: ["BundleDeals"],
      }),
      validateBundleDeal: build.mutation<
        ValidateBundleResponse,
        CreateBundleRequest
      >({
        query: (body) => ({
          url: `${SLUG}?action=validate`,
          method: "POST",
          body,
        }),
      }),
    }),
  });

export const {
  useGetAllBundleDealsQuery,
  useGetBundleDealByIdQuery,
  usePostBundleDealsMutation,
  usePutBundleDealsMutation,
  useDeleteBundleDealsMutation,
  useValidateBundleDealMutation,
} = injectedRtkApi;
